import React from 'react';
import { HasAccess } from 'components';
import { useParams } from 'react-router-dom';
import { Logs } from 'components/common/logs';
import { PERMISSIONS } from 'constants/permissions';

export const DealLogs: React.FC = () => {
  const { id } = useParams();
  return (
    <HasAccess role={PERMISSIONS.deals.logs.read}>
      <div className={'logs-layout-container'}>
        <Logs entityName={'DEAL'} id={id} />
      </div>
    </HasAccess>
  );
};

export default DealLogs;
